export default __webpack_public_path__ + "static/media/20140928_163553.76acd72c-min.28f0c6c6.jpg";